export default "__VITE_ASSET__CjjoI_yR__"